export default "__VITE_PUBLIC_ASSET__e5632c1e__"